import React, { FC } from 'react';

import { DeveloperProvider } from 'modules/Developer';

import HeaderDesktop from '../HeaderDesktop';
import HeaderMobile from '../HeaderMobile';

const Root: FC = () => (
  <DeveloperProvider>
    <HeaderDesktop />
    <HeaderMobile />
  </DeveloperProvider>
);

export default Root;
